// extracted by mini-css-extract-plugin
export var addressFields = "_mm-0";
export var animationContainer = "_mm-1";
export var footer = "_mm-2";
export var lineItems = "_mm-3";
export var modalContent = "_mm-4";
export var orderName = "_mm-5";
export var strong = "_mm-6";
export var warning = "_mm-7";